export default "__VITE_ASSET__BXuS107$__"